import { InjectionToken } from '@angular/core';
export var DESIGNER_SETTINGS_SERVICE = new InjectionToken('DESIGNER_SETTINGS_SERVICE');
